import React from 'react'
import { FieldProps } from '../FormDuuf'

// Elements
import Label from '../elements/Label'
import Error from '../elements/Error'

const TextAreaField: React.FC<FieldProps> = ({ formik = {}, hasError = false, fieldId, data }) => (
  <div className={`form-duuf-group form-duuf-group-${data.type}`}>
    <Label fieldId={fieldId} data={data} />
    <Error fieldId={fieldId} data={data} hasError={hasError} formik={formik} />
    <textarea
      className={`form-duuf-textarea form-duuf-textarea-${data.type}`}
      id={fieldId}
      name={fieldId}
      placeholder={data.placeholder}
      onBlur={formik.handleBlur}
      onChange={formik.handleChange}
      value={formik.values[fieldId]}
    />
  </div>
)

export default TextAreaField
